import { RouterModule } from '@angular/router';
import { DocsRecibidosManualmenteComponent } from './views/compras/docs-recibidos-manualmente/docs-recibidos-manualmente.component';
import { Dashboard1Component } from './views/dashboards/dashboard1/dashboard1.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { TimbrarDepositoComponent } from './views/finanzas/timbrar-deposito/timbrar-deposito.component';
import { ImprimirCargaCobranzasComponent } from './views/imprimir-carga-cobranzas/imprimir-carga-cobranzas.component';
import { ConsultaRecorridoComponent } from './views/liquidacion-recorridos/consulta-recorrido/consulta-recorrido.component';
import { TraspasoMasivoClienteComponent } from './views/mantenedores/traspaso-masivo-cliente/traspaso-masivo-cliente.component';
import { Map1Component } from './views/maps/map1/map1.component';
import { MercaderiaDevueltaComponent } from './views/mercaderia-devuelta/mercaderia-devuelta.component';
import { ModalsComponent } from './views/modals/modals.component';
import { Profile1Component } from './views/profile/profile1/profile1.component';
import { ConsultaDocumentoComponent } from './views/reportes/ventas/consulta-documento/consulta-documento.component';
import { BasicTableComponent } from './views/tables/basic-table/basic-table.component';
import { FacturaManualComponent } from './views/ventas/factura-manual/factura-manual.component';
import { FacturaTercerosComponent } from './views/ventas/factura-terceros/factura-terceros.component';
//Maestros
import { BancoComponent } from './views/banco/banco.component';
import { BodegaComponent } from './views/bodega/bodega.component';
import { CobradorComponent } from './views/cobrador/cobrador.component';
import { CondipagComponent } from './views/condipag/condipag.component';
import { LoginComponent } from './views/login/login.component';
import { CamionComponent } from './views/mantenedores/camion/camion.component';
import { ChoferComponent } from './views/mantenedores/chofer/chofer.component';
import { MixturaComponent } from './views/mantenedores/mixtura/mixtura.component';
import { ProveedorComponent } from './views/mantenedores/proveedor/proveedor.component';
import { UnidadMedidaComponent } from './views/mantenedores/unidadmedida/unidadmedida.component';
import { RutaComponent } from './views/ruta/ruta.component';
import { TerritorioComponent } from './views/territorio/territorio.component';
import { TipoclieComponent } from './views/tipoclie/tipoclie.component';
import { VendedorComponent } from './views/vendedor/vendedor.component';
import { ZonaComponent } from './views/zona/zona.component';
//Configuracion Usuarios
import { ClientesComponent } from './views/clientes/clientes.component';
import { AuditoriaComponent } from './views/configuracion-sistema/auditoria/auditoria.component';
import { CuentasBancariasEmpresaComponent } from './views/configuracion-sistema/cuentas-bancarias-empresa/cuentas-bancarias-empresa.component';
import { ModulosComponent } from './views/configuracion-sistema/modulos/modulos.component';
import { OperacionesComponent } from './views/configuracion-sistema/operaciones/operaciones.component';
import { RolesComponent } from './views/configuracion-sistema/roles/roles.component';
import { UsuariosComponent } from './views/configuracion-sistema/usuarios/usuarios.component';
import { NotificacionesComponent } from './views/notificaciones/notificaciones.component';
import { TipoCuentaComponent } from './views/tipo-cuenta/tipo-cuenta.component';
//Facturacion
import { AnalisisDemandaComponent } from './views/facturacion-masiva/analisis-demanda/analisis-demanda.component';
import { ConfirmarNotaVentaComponent } from './views/facturacion-masiva/confirmar-nota-venta/confirmar-nota-venta.component';
import { ImprimirFacturaComponent } from './views/facturacion-masiva/imprimir-factura/imprimir-factura.component';
import { RecepcionPedidosComponent } from './views/facturacion-masiva/recepcion-pedidos/recepcion-pedidos.component';
import { RecorridosComponent } from './views/recorridos/recorridos.component';
//Recorridos
import { DevolucionMercaderiaComponent } from './views/liquidacion-recorridos/devolucion-mecaderia/devolucion-mercaderia.component';
import { LiquidacionRecorridoComponent } from './views/liquidacion-recorridos/liquidacion-recorrido/liquidacion-recorrido.component';
import { RetornoMercaderiaComponent } from './views/liquidacion-recorridos/retorno-mercaderia/retorno-mercaderia.component';
//Recorridos
import { CChicaAgregarGastoComponent } from './views/c-chica-agregar-gasto/c-chica-agregar-gasto.component';
import { CChicaAperturaComponent } from './views/c-chica-apertura/c-chica-apertura.component';
import { CChicaConsultaMovFondoComponent } from './views/c-chica-consulta-mov-fondo/c-chica-consulta-mov-fondo.component';
import { CChicaRendicionGastoComponent } from './views/c-chica-rendicion-gasto/c-chica-rendicion-gasto.component';
import { CChicaSolicitudFondoRendirComponent } from './views/c-chica-solicitud-fondo-rendir/c-chica-solicitud-fondo-rendir.component';
import { CategoriasComponent } from './views/configuracion-sistema/categorias/categorias.component';
import { ControlEfectivoClienteComponent } from './views/control-efectivo-cliente/control-efectivo-cliente.component';
import { ControlEfectivoComponent } from './views/control-efectivo/control-efectivo.component';
import { DespachoRecorridoComponent } from './views/despacho-recorrido/despacho-recorrido.component';
import { DocumentoPorCobrarComponent } from './views/documento-por-cobrar/documento-por-cobrar.component';
import { CotizacionesComponent } from './views/cotizaciones/cotizaciones.component';
// Ventas
import { CotizacionComponent } from './views/ventas/cotizacion/cotizacion.component';
import { GuiaDespachoComponent } from './views/ventas/guia-despacho/guia-despacho.component';
import { NotaDebitoComponent } from './views/ventas/nota-debito/nota-debito.component';
import { NotaVentaComponent } from './views/ventas/nota-venta/nota-venta.component';
// Reportes y consultas
import { LibroVentaComponent } from './views/reportes/ventas/libro-venta/libro-venta.component';
import { TerritoriosAnualizadoComponent } from './views/reportes/ventas/territorios-anualizado/territorios-anualizado.component';
import { TerritoriosComponent } from './views/reportes/ventas/territorios/territorios.component';
import { VendedoresClientesComponent } from './views/reportes/ventas/vendedores-clientes/vendedores-clientes.component';
import { VendedoresFamiliaComponent } from './views/reportes/ventas/vendedores-familia/vendedores-familia.component';
import { VendedoresComponent } from './views/reportes/ventas/vendedores/vendedores.component';
import { LibroCompraComponent } from './views/reportes/compras/libro-compra/libro-compra.component';
import { ProductosAnualizadoComponent } from './views/reportes/productos/productos-anualizado/productos-anualizado.component';
import { ProductosGeneralComponent } from './views/reportes/productos/productos-general/productos-general.component';
import { ReporteGeneralComponent } from './views/reportes/productos/reporte-general/reporte-general.component';
import { ExistMovimientoESComponent } from './views/reportes/inventario/exist-movimiento-es/exist-movimiento-es.component';
import { ExistStockProductoComponent } from './views/reportes/inventario/exist-stock-producto/exist-stock-producto.component';
import { ReporteInventarioExistStockValorizadoComponent } from './views/reportes/inventario/exist-stock-valorizado/exist-stock-valorizado.component';
import { ReporteInventarioGeneralComponent } from './views/reportes/inventario/general/general.component';
import { MovimientoStockComponent } from './views/reportes/inventario/movimiento-stock/movimiento-stock.component';
import { ReporteInventarioSaldoSKUMesComponent } from './views/reportes/inventario/saldo-sku-mes/saldo-sku-mes.component';
import { HistoricoQuiebresComponent } from './views/reportes/historico-quiebres/historico-quiebres.component';
import { CoberturaIPTComponent } from './views/reportes/cliente/cobertura-ipt/cobertura-ipt.component';
import { DetalleProductosComponent } from './views/reportes/cliente/detalle-productos/detalle-productos.component';
import { EspecificoComponent } from './views/reportes/cliente/especifico/especifico.component';
import { VentasClientesComponent } from './views/reportes/cliente/ventas-clientes/ventas-clientes.component';
// Acciones Comerciales
import { ReglasComercialesComponent } from './views/acciones-comerciales/reglas-comerciales/reglas-comerciales.component';
// Inventario
import { ExistCalcPedidoComponent } from './views/inventario/exist-calc-pedido/exist-calc-pedido.component';
import { ExistDocElectronicosComponent } from './views/inventario/exist-doc-electronicos/exist-doc-electronicos.component';
import { ExistInventarioFisicoComponent } from './views/inventario/exist-inventario-fisico/exist-inventario-fisico.component';
import { ExistInventarioComponent } from './views/inventario/exist-inventario/exist-inventario.component';
// Cta. Cte. Cliente
import { CartolaClienteComponent } from './views/cta-cte-cliente/cartola-cliente/cartola-cliente.component';
import { ClientesMorososComponent } from './views/cta-cte-cliente/clientes-morosos/clientes-morosos.component';
import { ConsultarPagosComponent } from './views/cta-cte-cliente/consultar-pagos/consultar-pagos.component';
import { PagosClienteComponent } from './views/cta-cte-cliente/pagos-cliente/pagos-cliente.component';
import { ReversoPagosComponent } from './views/cta-cte-cliente/reverso-pagos/reverso-pagos.component';
import { SaldoClientesComponent } from './views/cta-cte-cliente/saldo-clientes/saldo-clientes.component';
// Finanzas
import { CajaDiariaComponent } from './views/finanzas/caja-diaria/caja-diaria.component';
import { ChequesCambiarFechaComponent } from './views/finanzas/cheques-cambiar-fecha/cheques-cambiar-fecha.component';
import { ChequesConsultarComponent } from './views/finanzas/cheques-consultar/cheques-consultar.component';
import { ChequesProtestoComponent } from './views/finanzas/cheques-protesto/cheques-protesto.component';
import { ChequesRedepositoComponent } from './views/finanzas/cheques-redeposito/cheques-redeposito.component';
import { DepositoDocumentosComponent } from './views/finanzas/deposito-documentos/deposito-documentos.component';
import { DepositoEfectivoComponent } from './views/finanzas/deposito-efectivo/deposito-efectivo.component';
import { DestinoDepositoComponent } from './views/finanzas/destino-deposito/destino-deposito.component';
import { TimbrarDepositoEfectivoComponent } from './views/finanzas/timbrar-deposito-efectivo/timbrar-deposito-efectivo.component';
// Maquinas
import { MaquinasInventarioClienteComponent } from './views/maquinas/maquinas-inventario-cliente/maquinas-inventario-cliente.component';
import { MaquinasInventarioVendedorComponent } from './views/maquinas/maquinas-inventario-vendedor/maquinas-inventario-vendedor.component';
import { MaquinasMaestroComponent } from './views/maquinas/maquinas-maestro/maquinas-maestro.component';
import { MaquinasReporteAntiguedadComponent } from './views/maquinas/maquinas-reporte-antiguedad/maquinas-reporte-antiguedad.component';
import { MaquinasReporteClienteComponent } from './views/maquinas/maquinas-reporte-cliente/maquinas-reporte-cliente.component';
import { MaquinasReporteUbicacionComponent } from './views/maquinas/maquinas-reporte-ubicacion/maquinas-reporte-ubicacion.component';
// Mantenedores
import { CheckinCheckoutComponent } from './views/mantenedores/checkin-checkout/checkin-checkout.component';
import { FamiliaComponent } from './views/mantenedores/familia/familia.component';
import { MaestroEquivalenciasComponent } from './views/mantenedores/maestro-equivalencias/maestro-equivalencias.component';
import { ProductosComponent } from './views/mantenedores/productos/productos.component';
import { RubroComponent } from './views/mantenedores/rubro/rubro.component';
import { TipoMovimientoComponent } from './views/mantenedores/tipo-movimiento/tipo-movimiento.component';
import { VendedorRubroComponent } from './views/mantenedores/vendedor-rubro/vendedor-rubro.component';
import { CanActivateGuard } from './shared/guards/can-activate.guard';
import { CentroCostoComponent } from './views/centro-costo/centro-costo.component';
import { CentroGastoComponent } from './views/centro-gasto/centro-gasto.component';
import { ClienteVendedorComponent } from './views/cliente-vendedor/cliente-vendedor.component';
import { CartolaProveedorComponent } from './views/cta-cte-proveedor/cartola-proveedores/cartola-proveedores.component';
import { CcProveedorPagosComponent } from './views/cta-cte-proveedor/cc-proveedor-pagos/cc-proveedor-pagos.component';
import { ConsultarPagosProveedoresComponent } from './views/cta-cte-proveedor/consultar-pagos-proveedores/consultar-pagos-proveedores.component';
import { DocsPorPagarProveedoresComponent } from './views/cta-cte-proveedor/docs-por-pagar-proveedores/docs-por-pagar-proveedores.component';
import { EmpresasComponent } from './views/empresas/empresas.component';
import { MotivosDevolucionComponent } from './views/mantenedores/motivos-devolucion/motivos-devolucion.component';
import { MaquinasCensoComponent } from './views/maquinas-censo/maquinas-censo.component';
import { MaquinasConsultaCensoComponent } from './views/maquinas-consulta-censo/maquinas-consulta-censo.component';
import { MaquinasReporteMovimientoComponent } from './views/maquinas-reporte-movimiento/maquinas-reporte-movimiento.component';
import { MaquinasReporteVendedorComponent } from './views/maquinas-reporte-vendedor/maquinas-reporte-vendedor.component';
import { ObjetivosComponent } from './views/objetivos/objetivos.component';
import { RuteadorManualComponent } from './views/ruteador-manual/ruteador-manual.component';
import { RuteadorComponent } from './views/ruteador/ruteador.component';
import { SucursalesComponent } from './views/sucursales/sucursales.component';
import { FormatosComponent } from './views/formatos/formatos.component';
import { BloqueoVistaGuard } from './shared/guards/bloqueo-vista.guard';
import { CanDeactivateGuard } from './shared/guards/can-deactivate.guard';
import { ModulosBloqueables } from './shared/object/modulos-bloqueables.enum';
import { EmpresasEmitidosComponent } from './views/analisis-eventos/empresas-emitidos/empresas-emitidos.component';
import { EmpresasRecibidosComponent } from './views/analisis-eventos/empresas-recibidos/empresas-recibidos.component';
import { BloqueoVistaErrorsComponent } from './views/bloqueo-vista/bloqueo-vista-errors/bloqueo-vista-errors.component';
import { NotaCreditoFTComponent } from './views/compras/nota-credito/nota-credito.component';
import { NotaCreditoComprasComponent } from './views/compras/recep-nota-credito/nota-credito.component';
import { BloqueoModuloActivoComponent } from './views/configuracion-sistema/bloqueo-modulo-activo/bloqueo-modulo-activo.component';
import { ParametroComponent } from './views/configuracion-sistema/parametro/parametro.component';
import { SesionesActivasUsuariosComponent } from './views/configuracion-sistema/sesiones-activas-usuarios/sesiones-activas-usuarios.component';
import { ReporteNcComponent } from './views/reporte-nc/reporte-nc.component';
import { NotaCreditoComponent } from './views/ventas/nota-credito/nota-credito.component';
const ɵ0 = { codigo_modulo: ModulosBloqueables.FACTURACION_MANUAL }, ɵ1 = { codigo_modulo: ModulosBloqueables.NOTA_DE_VENTA }, ɵ2 = { codigo_modulo: ModulosBloqueables.NOTA_DE_CREDITO }, ɵ3 = { codigo_modulo: ModulosBloqueables.NOTA_DE_DEBITO }, ɵ4 = { codigo_modulo: ModulosBloqueables.GUIA_DE_DESPACHO }, ɵ5 = { codigo_modulo: ModulosBloqueables.DEVOLUCION_MERCADERIA }, ɵ6 = { codigo_modulo: ModulosBloqueables.LIQUIDACION_RECORRIDO }, ɵ7 = { codigo_modulo: ModulosBloqueables.MERCADERIA_DEVUELTA }, ɵ8 = { codigo_modulo: ModulosBloqueables.CONSULTA_RECORRIDO }, ɵ9 = { codigo_modulo: ModulosBloqueables.RECEPCION_PEDIDOS }, ɵ10 = { codigo_modulo: ModulosBloqueables.ANALISIS_DEMANDA }, ɵ11 = { codigo_modulo: ModulosBloqueables.CONFIRMACION_NOTA_VENTA }, ɵ12 = { codigo_modulo: ModulosBloqueables.ASIGNACION_RUTEADOR }, ɵ13 = { codigo_modulo: ModulosBloqueables.ASIGNACION_MANUAL };
const routes = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboards/v1' },
    {
        path: 'bloqueo-vista-error',
        component: BloqueoVistaErrorsComponent,
    },
    {
        path: 'dashboards',
        children: [
            {
                path: 'v1',
                component: Dashboard1Component,
                canActivate: [CanActivateGuard]
            },
        ],
    },
    {
        path: 'profiles',
        children: [
            {
                path: 'profile1',
                component: Profile1Component,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'notificaciones',
        component: NotificacionesComponent,
        canActivate: [CanActivateGuard],
    },
    {
        path: 'tables',
        children: [
            {
                path: 'table1',
                component: BasicTableComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'maps',
        children: [
            {
                path: 'map1',
                component: Map1Component,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'ventas',
        children: [
            {
                path: 'facturacionManual',
                component: FacturaManualComponent,
                data: ɵ0,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'notaDeVenta',
                component: NotaVentaComponent,
                data: ɵ1,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [CanDeactivateGuard, BloqueoVistaGuard],
            },
            {
                path: 'notaDeCredito',
                component: NotaCreditoComponent,
                data: ɵ2,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'notaDeDebito',
                component: NotaDebitoComponent,
                data: ɵ3,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'guiaDeDespacho',
                component: GuiaDespachoComponent,
                data: ɵ4,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'cotizacion',
                component: CotizacionComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'recorridos',
        children: [
            {
                path: 'retornoMercaderia',
                component: RetornoMercaderiaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'devolucionMercaderia',
                component: DevolucionMercaderiaComponent,
                data: ɵ5,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'liquidacionRecorrido',
                data: ɵ6,
                component: LiquidacionRecorridoComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'controlEfectivo',
                component: ControlEfectivoComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'despachoRecorrido',
                component: DespachoRecorridoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'mercaderiaDevuelta',
                data: ɵ7,
                component: MercaderiaDevueltaComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
            {
                path: 'consultaRecorrido',
                data: ɵ8,
                component: ConsultaRecorridoComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard]
            },
        ],
    },
    {
        path: 'reportesConsultas',
        children: [
            {
                path: 'reporteNotaCredito',
                component: ReporteNcComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cotizaciones',
                component: CotizacionesComponent,
            },
            {
                path: 'existReportInventario',
                component: ReporteInventarioGeneralComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existStockProducto',
                component: ExistStockProductoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existMovimientoStock',
                component: MovimientoStockComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existStockValorizado',
                component: ReporteInventarioExistStockValorizadoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existSaldoSKU',
                component: ReporteInventarioSaldoSKUMesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existMovimientoES',
                component: ExistMovimientoESComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'historico-quiebres',
                component: HistoricoQuiebresComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'ventasClientes',
                component: VentasClientesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'coberturaIPT',
                component: CoberturaIPTComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'especifico',
                component: EspecificoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'detalleProductos',
                component: DetalleProductosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'vendedores',
                component: VendedoresComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'vendedoresFamilia',
                component: VendedoresFamiliaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'vendedoresClientes',
                component: VendedoresClientesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'territorios',
                component: TerritoriosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'territoriosAnualizado',
                component: TerritoriosAnualizadoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'productosGeneral',
                component: ProductosGeneralComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'productosAnualizado',
                component: ProductosAnualizadoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteGeneral',
                component: ReporteGeneralComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'libroVenta',
                component: LibroVentaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'libroCompra',
                component: LibroCompraComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'consultaDocumento',
                component: ConsultaDocumentoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'checkinCheckOut',
                component: CheckinCheckoutComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'facturacion',
        children: [
            {
                path: 'recepcionPedidos',
                component: RecepcionPedidosComponent,
                data: ɵ9,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'analisisDemanda',
                component: AnalisisDemandaComponent,
                data: ɵ10,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'confirmarNotaVenta',
                data: ɵ11,
                component: ConfirmarNotaVentaComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'recorridos',
                component: RecorridosComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'ruteador',
                component: RuteadorComponent,
                data: ɵ12,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'ruteadorManual',
                component: RuteadorManualComponent,
                data: ɵ13,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'imprimirFactura',
                component: ImprimirFacturaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'imrpimirListados',
                component: ImprimirCargaCobranzasComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'accionesComerciales',
        children: [
            {
                path: 'reglas-comerciales',
                component: ReglasComercialesComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'inventario',
        children: [
            {
                path: 'existInventario',
                component: ExistInventarioComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existInventarioFisico',
                component: ExistInventarioFisicoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existDocElectronicos',
                component: ExistDocElectronicosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'existCalcPedido',
                component: ExistCalcPedidoComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    //Análisis de Eventos Electrónicos
    {
        path: 'analisis-eventos',
        children: [
            {
                path: 'emitidos',
                component: EmpresasEmitidosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'recibidos',
                component: EmpresasRecibidosComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'cuentaCorriente',
        children: [
            {
                path: 'cartolaCliente',
                component: CartolaClienteComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'pagosCliente',
                component: PagosClienteComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'consultarPagos',
                component: ConsultarPagosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'saldoClientes',
                component: SaldoClientesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reversoPagos',
                component: ReversoPagosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'documentoPorCobrar',
                component: DocumentoPorCobrarComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'clientesMorosos',
                component: ClientesMorososComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'controlEfectivoCliente',
                component: ControlEfectivoClienteComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'cuentaCorrienteProveedor',
        children: [
            {
                path: 'pagos',
                component: CcProveedorPagosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'consultarPagos',
                component: ConsultarPagosProveedoresComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'docsPorPagar',
                component: DocsPorPagarProveedoresComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cartola',
                component: CartolaProveedorComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'finanzas',
        children: [
            {
                path: 'cChicaApertura',
                component: CChicaAperturaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cChicaSolicitudFondoRendir',
                component: CChicaSolicitudFondoRendirComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cChicaRendicionGasto',
                component: CChicaRendicionGastoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cChicaAgregarGasto',
                component: CChicaAgregarGastoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cChicaConsultaMovFondo',
                component: CChicaConsultaMovFondoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'depositoEfectivo',
                component: DepositoEfectivoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'timbrarDepositoEfectivo',
                component: TimbrarDepositoEfectivoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'chequesConsultar',
                component: ChequesConsultarComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'chequesCambiarFecha',
                component: ChequesCambiarFechaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'chequesProtesto',
                component: ChequesProtestoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'chequesRedeposito',
                component: ChequesRedepositoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cajaDiaria',
                component: CajaDiariaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'depositoDocumentos',
                component: DepositoDocumentosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'destinoDeposito/:id',
                component: DestinoDepositoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'timbrarDeposito',
                component: TimbrarDepositoComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'maquinas',
        children: [
            {
                path: 'maestro',
                component: MaquinasMaestroComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'inventarioVendedor',
                component: MaquinasInventarioVendedorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'inventarioCliente',
                component: MaquinasInventarioClienteComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'censo',
                component: MaquinasCensoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteVendedor',
                component: MaquinasReporteVendedorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteMovimiento',
                component: MaquinasReporteMovimientoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'consultaCenso',
                component: MaquinasConsultaCensoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteCliente',
                component: MaquinasReporteClienteComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteAntiguedad',
                component: MaquinasReporteAntiguedadComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'reporteUbicacion',
                component: MaquinasReporteUbicacionComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'maestros',
        children: [
            {
                path: 'traspasoMasivoCliente',
                component: TraspasoMasivoClienteComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'motivosDevolucion',
                component: MotivosDevolucionComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'motivosInventario',
                component: TipoMovimientoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'centroCosto',
                component: CentroCostoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'centroGasto',
                component: CentroGastoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'clienteVendedor',
                component: ClienteVendedorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'clientes',
                component: ClientesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'mixtura',
                component: MixturaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'productos',
                component: ProductosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'vendedor',
                component: VendedorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'territorio',
                component: TerritorioComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'banco',
                component: BancoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'tipos-cuenta',
                component: TipoCuentaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'bodega',
                component: BodegaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'camion',
                component: CamionComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'chofer',
                component: ChoferComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'zona',
                component: ZonaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'tipoclie',
                component: TipoclieComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'ruta',
                component: RutaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'rubro',
                component: RubroComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'familia',
                component: FamiliaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'objetivos',
                component: ObjetivosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'empresas',
                component: EmpresasComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'sucursales',
                component: SucursalesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'vendedor-rubro',
                component: VendedorRubroComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'unidadmedida',
                component: UnidadMedidaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'formatos',
                component: FormatosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'condipag',
                component: CondipagComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cobrador',
                component: CobradorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'proveedor',
                component: ProveedorComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'equivalencia-productos',
                component: MaestroEquivalenciasComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'configuracionSistema',
        children: [
            {
                path: 'usuarios',
                component: UsuariosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'sesiones-activas',
                component: SesionesActivasUsuariosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'roles',
                component: RolesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'categorias',
                component: CategoriasComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'modulos',
                component: ModulosComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'bloqueo-modulo-activo',
                component: BloqueoModuloActivoComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'operaciones',
                component: OperacionesComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'auditoria',
                component: AuditoriaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'cuentas-bancarias-empresas',
                component: CuentasBancariasEmpresaComponent,
                canActivate: [CanActivateGuard],
            },
            {
                path: 'parametro',
                component: ParametroComponent,
                canActivate: [CanActivateGuard],
            },
        ],
    },
    {
        path: 'compras',
        children: [
            {
                path: 'facturacionTercero',
                component: FacturaTercerosComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'notaDeCreditoFT',
                component: NotaCreditoFTComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'DocsRecibidosManualmente',
                component: DocsRecibidosManualmenteComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
            {
                path: 'RecepNotaCredito',
                component: NotaCreditoComprasComponent,
                canActivate: [CanActivateGuard, BloqueoVistaGuard],
                canDeactivate: [BloqueoVistaGuard],
            },
        ],
    },
    { path: 'modals', component: ModalsComponent },
    { path: 'login', component: LoginComponent },
    { path: '**', component: NotFoundComponent },
];
export const AppRoutes = RouterModule.forRoot(routes);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13 };
